import { $dark } from '@mgmresorts/wcl-styled';
import styled from 'styled-components';

export const StyledContent = styled.div`
  .identity__mgm-logo {
    align-self: flex-start;
  }

  .identity__verification-description {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #00012b;
    margin-bottom: 32px;
  }

  .identity__field {
    &.identity__field-mlifenumber {
      margin-bottom: 0;
    }

    &-email {
      margin-bottom: 32px;
    }

    &.identity__field-birthday {
      margin-bottom: 60px;
      &.with-error {
        margin-bottom: 60px;
      }
    }

    &.identity__field-activation-code {
      margin-bottom: 0;
      &.with-error {
        margin-bottom: 18px;
      }

      + .info {
        margin: 24px 0 0;

        a {
          text-decoration: underline;
          color: #00012b;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
        }
      }
    }
  }

  .identity__checkbox {
    margin-top: 25px;
  }

  .identity__header {
    margin: 32px 0 0 0;
  }

  .identity__step-button {
    margin-top: 40px;
  }

  .identity__form-submit {
    margin-top: 24px;
  }

  .identity__guestInfo-title {
    margin-top: 40px;
    width: 100%;
    font-weight: 500;
    font-size: 20px;
    line-height: 28px;
    color: #00012b;
  }

  .identity__address-title {
    margin-top: 40px;
    margin-bottom: 16px;
    width: 100%;
    font-weight: 500;
    font-size: 20px;
    line-height: 28px;
    color: #00012b;
  }

  .identity__address-subtitle {
    margin-bottom: 16px;
  }

  .identity__field-firstName {
    margin-top: 16px;
  }

  .identity__list-item {
    display: list-item;
    margin-left: 12px;
    color: ${$dark};
  }

  .identity__email-verified-success,
  .identity__account-activated-page {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &-info {
      margin: 12px 0 0;
      font-size: 18px;
      line-height: 1.56;
      color: #00012b;
      text-align: center;
    }
  }

  .identity__account-activated-page-info {
    max-width: 140px;
  }
`;
